<!-- Header Details Card -->
<div class="header-card bg-white" *ngIf="scenario_information_details" [ngClass]="{TabletProtrait: (responsiveService.deviceTablet() && responsiveService.orientationPortrait()),
    TabletLandscape: (responsiveService.deviceTablet() && responsiveService.orientationLandscape()), smallSize: responsiveService.screenSize === 'Small',
    WebPortrait:(responsiveService.deviceDesktop() && responsiveService.orientationPortrait())}">

    <!-- Scenario ID -->
    <ng-container *ngIf="scenario_information_details.scenario_id">
        <span class="details">
            <span class="header-name font-sm" *ngIf="pt_settings?.is_recommender">{{ "lang.header_details.recommendation_id" | translate }}</span>
            <span class="header-name font-sm" *ngIf="!pt_settings?.is_recommender">{{ "lang.header_details.scenario_id" | translate }}</span>
            <p class="header-value font-sm">
                <span *ngIf="scenario_information_details.scenario_id">
                    {{ scenario_information_details.scenario_id }}
                </span>
                <span *ngIf="!scenario_information_details.scenario_id"> - </span>
            </p>
        </span>
    </ng-container>

    <!-- Objective -->
    <ng-container>
        <span class="details">
            <span class="header-name font-sm">{{ "lang.header_details.objective" | translate }}</span>
            <p class="header-value font-sm objective">
                <span *ngIf="scenario_information_details.objective">
                    {{ new_pr_objective[scenario_information_details.objective] }} <mat-icon class="info_icon cursorPointer" (click)="openObjectivePopUP()">info</mat-icon>
                </span>
                <span *ngIf="!scenario_information_details.objective"> - </span>
            </p>
        </span>
    </ng-container>

    <!-- Scenario Name -->
    <ng-container *ngIf="scenario_information_details.name">
        <span class="details wider">
            <span class="header-name font-sm" *ngIf="pt_settings?.is_recommender">{{ "lang.header_details.recommendation_name" | translate }}</span>
            <span class="header-name font-sm" *ngIf="!pt_settings?.is_recommender">{{ "lang.header_details.scenario_name" | translate }}</span>
            <p class="header-value font-sm">
                <span *ngIf="scenario_information_details.name">
                    {{ scenario_information_details.name }}
                </span>
                <span *ngIf="!scenario_information_details.name"> - </span>
            </p>
        </span>
    </ng-container>

    <!-- Market -->
    <ng-container *ngIf="scenario_information_details.market">
        <span class="details">
            <span class="header-name font-sm">{{ "lang.header_details.market" | translate }}</span>
            <p class="header-value font-sm">
                <span *ngIf="scenario_information_details.market">
                    {{ scenario_information_details.market }}
                </span>
                <span *ngIf="!scenario_information_details.market"> - </span>
            </p>
        </span>
    </ng-container>

    <!-- Approved On -->
    <ng-container *ngIf="scenario_information_details.approved_at">
      <span class="details">
          <span class="header-name font-sm">{{ "lang.header_details.approved_at" | translate }}</span>
          <p class="header-value font-sm">
              <span *ngIf="scenario_information_details.approved_at">
                  {{ scenario_information_details.approved_at | customDatePipe | async }}
              </span>
              <span *ngIf="!scenario_information_details.approved_at"> - </span>
          </p>
      </span>
  </ng-container>

    <!-- Approved By -->
    <ng-container *ngIf="scenario_information_details.approved_by">
      <span class="details">
          <span class="header-name font-sm">{{ "lang.header_details.approved_by" | translate }}</span>
          <p class="header-value font-sm">
              <span *ngIf="scenario_information_details.approved_by">
                  {{ scenario_information_details.approved_by }}
              </span>
              <span *ngIf="!scenario_information_details.approved_by"> - </span>
          </p>
      </span>
  </ng-container>

    <!-- Created On -->
    <ng-container *ngIf="scenario_information_details.created_at">
        <span class="details">
            <span class="header-name font-sm">{{ "lang.header_details.created_at" | translate }}</span>
            <p class="header-value font-sm">
                <span *ngIf="scenario_information_details.created_at">
                    {{ scenario_information_details.created_at | customDatePipe | async }}
                </span>
                <span *ngIf="!scenario_information_details.created_at"> - </span>
            </p>
        </span>
    </ng-container>

    <!-- Created By -->
    <ng-container *ngIf="scenario_information_details.created_by">
        <span class="details">
            <span class="header-name font-sm">{{ "lang.header_details.created_by" | translate }}</span>
            <p class="header-value font-sm">
                <span *ngIf="scenario_information_details.created_by">
                    {{ scenario_information_details.created_by }}
                </span>
                <span *ngIf="!scenario_information_details.created_by"> - </span>
            </p>
        </span>
    </ng-container>

    <!-- Effective Date -->
    <ng-container *ngIf="scenario_information_details.hasOwnProperty('effective_date')">
      <span class="details">
        <span class="header-name font-sm" *ngIf="scenario_information_details.status_id == approved_code">{{ "lang.header_details.effective_date" | translate }}</span>
        <span class="header-name font-sm" *ngIf="!pt_settings?.create_scenario && scenario_information_details.status_id != approved_code">{{ "lang.header_details.planning_cycle_date" | translate }}</span>
        <span class="header-name font-sm" *ngIf="pt_settings?.create_scenario">{{"lang.header_details.optimiser_planning_cycle_date" | translate}}</span>
          <p class="header-value font-sm">
              <span *ngIf="scenario_information_details.effective_date && scenario_information_details.status_id == approved_code">
                  {{ scenario_information_details.effective_date | customDatePipe | async }}
              </span>
              <span *ngIf="scenario_information_details.planned_cycle_date && scenario_information_details.status_id != approved_code">
                  {{ scenario_information_details.planned_cycle_date | customDatePipe:'MMM-YYYY' | async }}
              </span>
              <span *ngIf="!scenario_information_details.effective_date && !scenario_information_details.planned_cycle_date"> - </span>
          </p>
      </span>
    </ng-container>

    <ng-container *ngIf="pt_settings.planning_cycle_date">
      <span class="details">
        <span class="header-name font-sm" *ngIf="pt_settings?.create_scenario">{{"lang.header_details.selected_planning_cycle_date" | translate}}</span>
          <p class="header-value font-sm">
              <span >
                  {{ pt_settings.planning_cycle_date | customDatePipe:'MMM-YYYY' | async }}
              </span>
          </p>
      </span>
    </ng-container>

    <!-- Stores Affected -->
    <ng-container *ngIf="scenario_information_details.hasOwnProperty('stores')"> <!-- *ngIf="scenario_information_details.stores"-->
        <span class="details">
            <span class="header-name font-sm">{{ "lang.header_details.stores" | translate }}</span>
            <p class="header-value font-sm">
                <span *ngIf="scenario_information_details.stores">
                    {{ scenario_information_details.stores }}
                </span>
                <span *ngIf="!scenario_information_details.stores"> - </span>
            </p>
        </span>
    </ng-container>

    <!-- Status -->
    <ng-container  *ngIf="scenario_information_details.status">
        <span class="details">
            <span class="header-name font-sm">{{ "lang.header_details.status" | translate }}</span>
            <p class="header-value font-sm">
                <span *ngIf="scenario_information_details.status">
                    <mat-icon class="font-size-sm" [ngStyle]="{ 'color': status_color[status_id] }">lens</mat-icon>
                    {{ status_text[scenario_information_details.status_id] | translate }}
                </span>
                <span *ngIf="!scenario_information_details.status"> - </span>
            </p>
        </span>
    </ng-container>
</div>

<!-- Objective Modal -->
<div class="backdrop" [ngClass]="{'d-none': !objective_flag, 'd-block': objective_flag}">
</div>
<div class="modal constraint_popup" tabindex="-1" role="dialog"
  [ngClass]="{'d-none': !objective_flag, 'd-block': objective_flag}">
  <!-- modal-dialog -->
  <div class="modal-dialog modal-dialog-centered" role="document">
    <!-- modal-content -->
    <div class="modal-content">

      <!-- modal-header -->
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="closePopup()"><span
            aria-hidden="true">&times;</span></button>
      </div>

      <!-- modal-body -->
      <div class="modal-body cancelBody">
        <h4 class="modal-title header_label_portal text-black mt-1 costa_text" *ngIf="objective_flag && data_source.data.length>0">
          {{"lang.new_price_recommender.constraints" | translate}}
        </h4>
        <div class="constraints-list-table" *ngIf="data_source.data.length>0">

            <!-- table viewport -->
            <cdk-virtual-scroll-viewport [tvsItemSize]="item_size" [ngStyle]="{'height.px': view_port_height }"
              class="wrapper mat-elevation-z2" #view_port>

              <table mat-table #table matSort [dataSource]="data_source">

                <!-- Constraint Type Column -->
                <ng-container matColumnDef="constraint_type">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.price_recommendation.constraint_table_headers.constraint_type" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row" class="center-align-text"> {{row.constraint_desc}} </td>
                </ng-container>

                <!-- Constraint Drill-Down Column -->
                <ng-container matColumnDef="constraint_drill">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.price_recommendation.constraint_table_headers.constraint_drill" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row"> {{ row.constraint_value }} </td>
                </ng-container>

                <!-- Minimum Value Column -->
                <ng-container matColumnDef="minimum_value">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.price_recommendation.constraint_table_headers.minimum_value" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row"> {{row.minimum_value}} </td>
                </ng-container>

                <!-- Maximum Value Column -->
                <ng-container matColumnDef="maximum_value">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.price_recommendation.constraint_table_headers.maximum_value" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row"> {{row.maximum_value}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="constraint_table_columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: constraint_table_columns;"></tr>

              </table>
            </cdk-virtual-scroll-viewport>
          </div>
        
        <h4 class="modal-title header_label_portal text-black mt-1 costa_text" *ngIf="objective_flag && data_source2.data.length>0">
          {{"lang.new_price_recommender.items_held" | translate}}
        </h4>
        <div class="item-details-list-table" *ngIf="data_source2.data.length>0">

            <!-- table viewport -->
            <cdk-virtual-scroll-viewport [tvsItemSize]="item_size2" [ngStyle]="{'height.px': view_port_height2 }"
              class="wrapper mat-elevation-z2" #view_port2>

              <table mat-table #table matSort [dataSource]="data_source2">
                <!-- Product Category Column -->
                <ng-container matColumnDef="product_category">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.price_recommendation.item_details_headeres.category" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row" class="center-align-text"> {{row.product_category}} </td>
                </ng-container>

                <!-- Products Column -->
                <ng-container matColumnDef="items">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.price_recommendation.item_details_headeres.product" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row"> {{ row.items }} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="item_details_table_columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: item_details_table_columns;"></tr>

              </table>
            </cdk-virtual-scroll-viewport>
          </div>

          <h4 class="modal-title header_label_portal text-black mt-1 costa_text" *ngIf="objective_flag && price_band_data_source.data.length>0">
            {{"lang.pricebandConfiguration.table_details.heading" | translate}}
          </h4>

          <div class="item-details-list-table" *ngIf="price_band_data_source.data.length>0">

            <!-- table viewport -->
            <cdk-virtual-scroll-viewport [tvsItemSize]="item_size2" [ngStyle]="{'height.px': view_port_height2 }"
              class="wrapper mat-elevation-z2" #view_port3>

              <table mat-table #table matSort [dataSource]="price_band_data_source">
                <!-- Product Category Column -->
                <ng-container matColumnDef="product_category">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.pricebandConfiguration.table_details.spar_priceband" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row" class="center-align-text"> {{row.geo_desc}} </td>
                </ng-container>

                <!-- Products Column -->
                <ng-container matColumnDef="items">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.pricebandConfiguration.table_details.elasticity_price_band" | translate}} 

                  </th>
                  <td mat-cell *matCellDef="let row"> {{ row.geo_elasticity_desc }} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="item_details_table_columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: item_details_table_columns;"></tr>

              </table>
            </cdk-virtual-scroll-viewport>
          </div>
      </div>

      <!-- modal-footer -->
      <div class="modal-footer">

      </div>
    </div>
  </div>
</div>